/**
 * A row action (close/reopen) moves a section out of `currentView` into another status view.
 * If that section was the only one in the current view (`totalResultsInCurrentView === 1`),
 * the view is now empty and the caller should switch to the destination view rather than
 * refreshing the current one. Guarded on `currentView === sourceView` so the switch only
 * happens from the view the action is actually offered in.
 */
export const shouldSwitchSectionView = (
  currentView: string | null,
  sourceView: string,
  totalResultsInCurrentView: number | undefined
): boolean => currentView === sourceView && (totalResultsInCurrentView ?? 0) === 1
